(function () {
    angular.module('tradersyard').component('tyChatMessageContent', {
        // language=HTML
        template:
            '<div ng-switch="$ctrl.messageType" class="ty-chat-message-content">\n    \n    <div ng-switch-when="action" ng-switch="$ctrl.actionType" ng-click="$ctrl.onActionClick($ctrl.messageContent)">\n        \n        <div ng-switch-when="meeting.invite" class="action meeting-invite">\n            <i class="fa fa-2x fa-phone"></i>\n            <div class="action-message">\n                <p>{{$ctrl.messageContent.inviterName}} has invited you to join a meeting.</p>\n                <p>Click here to join {{$ctrl.messageContent.meetingName}}.</p>\n            </div>\n        </div>\n        \n    </div>\n    \n    <div ng-switch-when="message"\n         class="message content hyphenate"\n         ng-bind-html="$ctrl.messageContent|markdown|moji:\'ldpi\'">\n    </div>\n</div>\n\n\n\n',
        bindings: {
            messageType: '<',
            messageContent: '<',
        },
        controller: ChatMessageContentController,
    });

    ChatMessageContentController.$inject = ['$window'];

    /**
     * Displays chat message or action. Not all action types get through here.
     * Some actions are filtered in the Message Manager.
     *
     * We should try to improve the situation by having some parent <ty-chat-message> component,
     * that would handle other message related UI logic and maybe further control the looks.
     *
     * @param {Window} $window
     * @constructor
     */
    function ChatMessageContentController($window) {
        var ctrl = this;

        /**
         * @type {string|'meeting.invite'}
         */
        ctrl.actionType = '';

        /**
         * @type {'message'|'action'}
         */
        ctrl.messageType = 'message';

        /**
         * @typedef ActionMessageContent
         * @property {string}   type      Possible action type
         * @property {string}   [joinUrl]   ChoopChat meeting URL with JWT
         *
         * @type {ActionMessageContent|string}
         */
        ctrl.messageContent = undefined;

        /**
         * Initialize action type property for action type messages.
         */
        ctrl.$onChanges = function () {
            if (ctrl.messageType !== 'action') {
                return;
            }

            ctrl.actionType = ctrl.messageContent.type;
        };

        /**
         * @param {ActionMessageContent} messageContent
         */
        ctrl.onActionClick = function (messageContent) {
            if (messageContent.type === 'meeting.invite') {
                $window.open(messageContent.joinUrl, '_blank');
            }
        };
    }
})();
